import { createFileRoute } from "@tanstack/react-router";
import { FaqPage } from "@/components/contacts/FaqPage";
import { faqSeo } from "@/lib/page-seo";

export const Route = createFileRoute("/faq")({
  loader: ({ location }) => ({ href: location.href }),
  head: ({ loaderData }) => faqSeo(loaderData?.href ?? "/faq"),
  component: FaqPage,
});
